import cx from 'classnames';
import { Arrow } from 'education-icons';
import { Button, SimpleText } from 'platform-components';
import React from 'react';

import './detailed-view__return-button.scss';

interface Props {
    mix?: string;
    onClick: () => void;
    textId: string;
}

export const LessonViewDetailedViewReturnButton = React.forwardRef(({ mix, onClick, textId }: Props) => {
    return (
        <Button
            className={cx('detailed-view__return-button', mix)}
            icon={<Arrow />}
            onClick={onClick}
            view={Button.VIEW.CLEAR}
        >
            <SimpleText id={textId} />
        </Button>
    );
});
